// Module
var code = "<div class=\"widget-container\"> Tree </div>";
// Exports
module.exports = code;